<template>
  <div class="metadata-area">
    <div class="outer-wrapper">
      <div class="inner-wrapper">
        <div v-if="brandLogo" class="brand-logo">
          <img
            :src="require(`@/assets/images/detail/logo_${brandLogo}.png`)"
            :alt="`${brandLogo} 로고`"
          />
        </div>

        <h1 class="main-title">{{ seasonTitle }}</h1>

        <PlayerMetaData
          :key="`${seasonTitle}__meta_data`"
          :content-info="contentInfo"
          :content-type="contentType"
        />

        <PlayerComments
          :key="`${seasonTitle}__player_comments`"
          :comment-list="comments"
        />

        <PlayerIconButtons
          :key="`${seasonTitle}__icon_button`"
          :content-info="contentInfo"
          :content-type="contentType"
        />

        <div class="essential-buttons">
          <VodFilterList
            v-if="hasSeason"
            :current-season="contentId"
            :filter-item="seasonList"
            :base-api="seasonList.baseApi"
          />

          <PlayerActionButton
            :key="`${seasonTitle}__player_action_button`"
            :content-info="contentInfo"
            :landing-info="landingInfo"
            :content-type="contentType"
            @on-click-player="clickPlayerFn"
          />
        </div>

        <PlayerDetail
          :key="`${seasonTitle}__detail_info`"
          :contents-status="contentsStatus"
          :content-info="contentInfo"
          :content-type="contentType"
          @on-click-more="moveToDetailInfo"
        />
      </div>
    </div>

    <div v-if="hasNoticeList || hasEventList" class="outer-wrapper">
      <div class="inner-wrapper">
        <NoticeList v-if="hasNoticeList" :notice-list="noticeList" />

        <EventBannerList v-if="hasEventList" :event-banner-list="eventList" />
      </div>
    </div>
  </div>
</template>
<script>
  import { get } from 'lodash'
  import { topTagList } from '@/common/directives'
  import { PATH_NAME_PLAYER_VOD_DETAIL_INFO } from '@/common/router.const'
  import { PLAYER_TYPE } from '@/common/player.const'

  // components
  import EventBannerList from '@/components/play/EventBannerList'
  import NoticeList from '@/components/play/NoticeList'
  import PlayerActionButton from '@/components/play/detail/PlayerActionButton.vue'
  import PlayerComments from '@/components/play/detail/PlayerComments.vue'
  import PlayerDetail from '@/components/play/detail/PlayerDetail.vue'
  import PlayerIconButtons from '@/components/play/detail/PlayerIconButtons.vue'
  import PlayerMetaData from '@/components/play/detail/PlayerMetaData.vue'
  import VodFilterList from '@/components/section/template/VodFilterList'

  export default {
    name: 'VodPlayerDetailInfo',
    components: {
      PlayerMetaData,
      PlayerActionButton,
      NoticeList,
      EventBannerList,
      VodFilterList,
      PlayerDetail,
      PlayerComments,
      PlayerIconButtons,
    },
    directives: {
      topTagList,
    },
    props: {
      contentInfo: {
        type: Object,
        default: () => {},
      },
      clickPlayerFn: {
        type: Function,
      },
      noticeList: {
        type: Array,
        default: null,
      },
      eventList: {
        type: Array,
        default: null,
      },
      landingInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        contentType: PLAYER_TYPE.VOD,
      }
    },
    computed: {
      brandLogo() {
        const wavveLogo = ['original', 'only']
        const brandLogo = get(this.contentInfo, 'brand_logolist.0', '')
        return wavveLogo.includes(brandLogo) ? `wavve_${brandLogo}` : brandLogo
      },
      contentId() {
        return get(this.contentInfo, 'programid', '')
      },
      comments() {
        const { autocomment = '', comment = '' } = this.contentInfo
        return [autocomment, comment]
      },
      contentsStatus() {
        return get(this.landingInfo, 'contents_status', '')
      },
      seasonList() {
        const { season_list: seasonList = {} } = this.contentInfo
        const {
          count = '0',
          base_api: baseApi = '',
          season_item_list: seasonItemList = [],
        } = seasonList

        return { count, baseApi, seasonItemList }
      },
      seasonTitle() {
        return this.contentInfo?.seasontitle || ''
      },
      section() {
        const { type = '' } = this.contentInfo
        return type === 'general' ? 'vod' : 'qvod'
      },
      hasEventList() {
        return this.eventList.length > 0
      },
      hasSeason() {
        return Number(this.seasonList.count) > 1
      },
      hasNoticeList() {
        return (this.noticeList || []).length > 0
      },
    },
    methods: {
      moveToDetailInfo() {
        const { content_id: contentId = '' } = this.landingInfo
        const synopsis =
          this.contentsStatus === 'continue' || this.remainViewTime > 0
            ? 'episode'
            : 'season'

        this.$router.push({
          name: PATH_NAME_PLAYER_VOD_DETAIL_INFO,
          query: {
            contentid: contentId,
            synopsis: synopsis,
          },
        })
      },
    },
  }
</script>
